import { memo, ReactElement, useCallback, useMemo } from 'react';
import { BaseFilterChip } from './BaseFilterChip';
import { FilterChipProps } from './common';
import { DateTime } from 'luxon';
import { DateRangeFilterProps } from '../Primitives/DateRangeFilter';
import { useTranslation } from 'react-i18next';

export const DateRangeFilterChip = memo(function ({
  displayName,
  onValueChange,
  value,
}: FilterChipProps<DateRangeFilterProps>): ReactElement {
  const { t } = useTranslation();
  const handleRemove = useCallback(
    function (): void {
      if (onValueChange) {
        onValueChange(undefined);
      }
    },
    [onValueChange]
  );

  const filterValueText = useMemo(
    function (): string {
      if (value?.range?.gte !== undefined && value?.range?.lt !== undefined) {
        return t('filter.dateRange.between', {
          earlier: formatDate(value.range.gte),
          later: formatDate(value.range.lt),
        });
      } else if (value?.range?.gte !== undefined) {
        return t('filter.dateRange.from', { earlier: formatDate(value.range.gte) });
      } else if (value?.range?.lt !== undefined) {
        return t('filter.dateRange.to', { later: formatDate(value.range.lt) });
      } else {
        return '';
      }
    },
    [value, t]
  );

  return (
    <>
      {value && (
        <BaseFilterChip onRemove={handleRemove}>
          {t(displayName)}: {filterValueText}
        </BaseFilterChip>
      )}
    </>
  );
});

function formatDate(dateString: string): string {
  const date = DateTime.fromISO(dateString);
  return date.isValid ? date.toFormat('dd.MM.yyyy HH:mm') : dateString;
}
